import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Moment from 'moment';
import DateTime from '_class/DateTime';
import swal from 'sweetalert2';
import { isUserStudent, getUserAssessmentDates } from 'helpers/user';
import { getSection, updateArchived, getArchievedMentorGroups, getEducationGroups, getMentorGroups, getArchivedEducationGroups, clearSectionAttendanceStats, getStudentAttendance, clearStudentAttendance } from 'actions/sections';
import { setPageTitle } from 'actions/header';
import MentorSectionForm from 'containers/Forms/MentorSectionForm';
import SectionForm from 'containers/Forms/SectionForm';
import Modal from 'containers/Modals/Modal';
import MyTasks from 'containers/Overview/Sections/MyAssignments';
import UserMentorSection from 'components/List/UserMentorSection';
import SectionProgress from 'containers/Progress/Section';
import TeacherSectionProgress from 'containers/Progress/TeacherSection';
import SectionInformation from '../Functionality/SectionInformation';
import SectionPlans from '../Functionality/SectionPlans';
import SectionPosts from '../Functionality/SectionPosts';
import SectionTools from '../Functionality/SectionTools';
import DatePickers from 'containers/Progress/Partials/DatePickers';
import { Spinner } from 'UI';
import { Button, translate } from '@haldor/ui';

var UpperSecondarySchoolSection = /*#__PURE__*/function (_Component) {
  _inherits(UpperSecondarySchoolSection, _Component);

  var _super = _createSuper(UpperSecondarySchoolSection);

  function UpperSecondarySchoolSection(props) {
    var _this;

    _classCallCheck(this, UpperSecondarySchoolSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('hashchange', _this.onHashChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onHashChange", function () {
      if (window.location.hash == '#attendance') {
        if (_this.props.group.type == 'MENTOR_GROUP' && _this.props.studentAttendances.length == 0) {
          _this.getAttendanceData();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getAttendanceData", function () {
      var start = Moment(_this.state.start).format("YYYY-MM-DD");
      var end = Moment(_this.state.end).format("YYYY-MM-DD");

      _this.props.clearStudentAttendance();

      _this.props.group.students.forEach(_this.delayLoop(function (student) {
        _this.props.getStudentAttendance(student.id, start, end);
      }), 200);
    });

    _defineProperty(_assertThisInitialized(_this), "delayLoop", function (fn, delay) {
      return function (x, i) {
        setTimeout(function () {
          fn(x);
        }, i * delay);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "isUserOwner", function () {
      var _this$props = _this.props,
          currentUser = _this$props.currentUser,
          group = _this$props.group;

      if (currentUser == null || group == null) {
        return false;
      }

      var foundOwner = group.owners.find(function (owner) {
        return currentUser.id == owner.id;
      });

      if (foundOwner != null) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "EditButton", function () {
      var isStudent = isUserStudent(_this.props.currentUser);

      var isOwner = _this.props.group.owners.find(function (owner) {
        return owner.userId == _this.props.currentUser.id;
      });

      if (!isStudent && isOwner != null) {
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
          onClick: _this.openModal,
          type: "secondary",
          disabled: _this.props.group.archived
        }, _this.props.translate('Edit')));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "ArchiveButton", function () {
      var isStudent = isUserStudent(_this.props.currentUser);

      if (isStudent == false) {
        return /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: _this.makeArchive
        }, _this.props.translate(_this.props.group.archived ? 'Restore' : 'Archive'));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "makeArchive", function () {
      var groupId = _this.props.match.params.groupId;
      var _this$props2 = _this.props,
          group = _this$props2.group,
          translate = _this$props2.translate;
      swal.fire({
        title: translate('are-you-sure'),
        html: group.archived ? translate('Are you sure you want to reset this group?') : translate('Both the group and the Microsoft Team will be archived.<br /><br />Do you want to archive this group?'),
        showCancelButton: true,
        cancelButtonText: translate('No'),
        confirmButtonText: translate('Yes')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.updateArchived(group).then(function (response) {
            if (response.status < 300) {
              _this.setState({
                loading: true
              });

              _this.props.getSection(groupId).then(function () {
                _this.setState({
                  loading: false
                });
              });

              if (group.type == 'EDUCATION_GROUP') {
                _this.props.getEducationGroups();
              }

              if (group.type == 'MENTOR_GROUP') {
                _this.props.getMentorGroups();
              }
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (reRender, skipPrompt) {
      if (skipPrompt) {
        var groupId = _this.props.match.params.groupId;

        if (reRender) {
          _this.setState({
            loading: true
          });

          _this.props.getSection(groupId).then(function () {
            _this.setState({
              loading: false
            });
          });
        }

        _this.setState({
          modalIsOpen: false
        });
      } else {
        _this.setState({
          modalIsOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateStats", function () {
      _this.props.clearStudentAttendance();

      _this.props.group.students.forEach(function (student) {
        _this.props.getStudentAttendance(student.id, _this.state.start, _this.state.end);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMentorGroupActions", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '2em'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement(DatePickers, {
        startDate: _this.state.start,
        endDate: _this.state.end,
        onChange: _this.onDateChange
      }), /*#__PURE__*/React.createElement(Button, {
        style: {
          marginLeft: 0,
          marginTop: '1em'
        },
        onClick: _this.onUpdateStats
      }, _this.props.translate('update')))))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), _this.renderDateFilterText());
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupContent", function () {
      var group = _this.props.group;
      var isStudent = isUserStudent(_this.props.currentUser);
      var hasAssignments = _this.props.services.haldor || _this.props.services.microsoft;
      return /*#__PURE__*/React.createElement("div", {
        className: "single-group single-task"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.modalIsOpen,
        onClose: _this.closeModal,
        title: group.title
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: _this.closeModal,
        editView: true,
        section: group
      })), /*#__PURE__*/React.createElement(SectionTools, {
        EditButton: _this.EditButton,
        ArchiveButton: _this.ArchiveButton,
        group: group
      }), /*#__PURE__*/React.createElement(SectionInformation, {
        group: group
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), _this.props.services.news ? /*#__PURE__*/React.createElement("div", {
        id: "section-posts",
        className: "section",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionPosts, {
        groupid: group.id,
        archived: _this.props.group.archived,
        disableCreate: !_this.isUserOwner()
      })) : null, _this.props.services.plans ? /*#__PURE__*/React.createElement("div", {
        id: "section-planning",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionPlans, {
        groupid: group.id,
        dateRestriction: false,
        locked: group.locked,
        archived: _this.props.group.archived,
        disableCreate: !_this.isUserOwner()
      })) : null, hasAssignments ? /*#__PURE__*/React.createElement("div", {
        id: "section-groups",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(MyTasks, {
        groupid: group.id,
        locked: group.locked,
        archived: _this.props.group.archived,
        disableCreate: !_this.isUserOwner(),
        overview: true
      })) : null, group.students && group.students.length > 0 && !isStudent ? /*#__PURE__*/React.createElement("div", {
        id: "section-pupils",
        className: "single-section form",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(TeacherSectionProgress, {
        groupId: group.id
      })) : null, isStudent ? /*#__PURE__*/React.createElement("div", {
        id: "section-assessment",
        className: "single-section form",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionProgress, {
        groupId: _this.props.group.id,
        userId: _this.props.currentUser.id
      })) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      var start = dates.start,
          end = dates.end;
      localStorage.setItem('assessment-start-date', new DateTime(start).getDateStamp());
      localStorage.setItem('assessment-end-date', new DateTime(end).getDateStamp());

      _this.setState({
        start: start,
        end: end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderDateFilterText", function () {
      if (Moment().isSame(Moment(_this.state.end), 'day')) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red',
          marginLeft: '1rem',
          marginTop: '1rem',
          fontWeight: 'bold'
        }
      }, _this.props.translate('Showing data between'), " ", Moment(_this.state.start).format('YYYY-MM-DD'), " ", _this.props.translate('to').toLowerCase(), " ", Moment(_this.state.end).format('YYYY-MM-DD'));
    });

    var hasHaldorAssignments = null;
    var hasMicrosoftAssignments = null;
    _this.state = {
      modalIsOpen: false,
      loading: false,
      start: getUserAssessmentDates().start,
      end: getUserAssessmentDates().end
    };
    return _this;
  }

  _createClass(UpperSecondarySchoolSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var groupId = this.props.match.params.groupId;

      if (groupId != null && groupId != undefined && groupId != "") {
        this.setState({
          loading: true
        });
        this.props.getSection(groupId, true, 'members_expand').then(function () {
          _this2.setState({
            loading: false
          });

          if (_this2.props.group != null) {
            _this2.props.setPageTitle(_this2.props.group.title);

            if (window.location.hash == '#attendance') {
              if (_this2.props.group.type == 'MENTOR_GROUP' && _this2.props.studentAttendances.length == 0) {
                _this2.getAttendanceData();
              }
            }
          }
        });
      }

      window.addEventListener('hashchange', this.onHashChange, false);
    }
  }, {
    key: "renderMentorGroup",
    value: function renderMentorGroup() {
      var group = this.props.group;
      var isStudent = isUserStudent(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "single-group single-task"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modalIsOpen,
        onClose: this.closeModal,
        title: group.title
      }, /*#__PURE__*/React.createElement(MentorSectionForm, {
        onAbort: this.closeModal,
        editView: true,
        section: group
      })), /*#__PURE__*/React.createElement(SectionTools, {
        EditButton: this.EditButton,
        ArchiveButton: this.ArchiveButton,
        group: group
      }), /*#__PURE__*/React.createElement(SectionInformation, {
        group: group
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), this.props.services.plans ? /*#__PURE__*/React.createElement("div", {
        id: "section-posts",
        className: "section single-section",
        style: {
          border: 0,
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionPosts, {
        groupid: group.id,
        disableCreate: !this.isUserOwner()
      })) : null, group.students && group.students.length > 0 && !isStudent ? /*#__PURE__*/React.createElement("div", {
        id: "section-pupils",
        className: "single-section form",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(UserMentorSection, {
        section: group,
        attendance: this.props.studentAttendances,
        renderActions: this.renderMentorGroupActions,
        start: Moment(this.state.start).format('YYYY-MM-DD'),
        end: Moment(this.state.end).format('YYYY-MM-DD')
      })) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var group = this.props.group;

      if (!group || this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      switch (group.type) {
        case "EDUCATION_GROUP":
          return this.renderGroupContent();

        case "MENTOR_GROUP":
          return this.renderMentorGroup();

        default:
          return this.renderGroupContent();
      }
    }
  }]);

  return UpperSecondarySchoolSection;
}(Component);

function mapStateToProps(state) {
  return {
    group: state.sections.activeSection,
    translate: translate(state.Languages.translations),
    attendance: state.sections.sectionAttendance,
    currentUser: state.user.currentUser,
    studentAttendances: state.sections.studentAttendanceStats,
    services: state.Services.availableServices
  };
}

export default withRouter(connect(mapStateToProps, {
  getSection: getSection,
  setPageTitle: setPageTitle,
  updateArchived: updateArchived,
  getEducationGroups: getEducationGroups,
  getMentorGroups: getMentorGroups,
  getArchivedEducationGroups: getArchivedEducationGroups,
  getArchievedMentorGroups: getArchievedMentorGroups,
  clearSectionAttendanceStats: clearSectionAttendanceStats,
  getStudentAttendance: getStudentAttendance,
  clearStudentAttendance: clearStudentAttendance
})(UpperSecondarySchoolSection));